/*import { toggleText } from './Util.js';*/
import {LIB_URL} from '../App';
import {scrollToElement, loadLibrary} from './Util.js';

let container = $('.page-contacts');
let firstLoad = true;
let mapContainer;
let map;
let jsonURL;
let points;
let allCities = [];
let allOffices = [];
let allOfficesById = {};
let countriesMarkers = [];
let citiesMarkers = [];
let officesMarkers = [];
let officeMarker;
let defaultMapZoom = 5;
let defaultCountryZoom = 5;
let defaultCityZoom = 11;
let defaultOfficeZoom = 17;
let previousZoom = defaultMapZoom;
let defaultCenter = [49.755826, 36.6173];
let currentCountry = false;
let currentCity = false;
/*let currentOffice = false;*/
let markerIcon = '/img/marker.gif';
let mapOptions = {
    //controls: ['zoomControl', 'fullscreenControl'],
    controls: [],
    // Координаты центра карты.
    // Порядок по умолчнию: «широта, долгота».
    center: defaultCenter,
    // Уровень масштабирования. Допустимые значения:
    // от 0 (весь мир) до 19.
    zoom: defaultMapZoom
};
let placemarkData = {};
/*let baloonData = {};*/

let defaultCenterElement = $('[data-default-center]');
if (defaultCenterElement.length) {
    mapOptions.center = defaultCenter = defaultCenterElement.data('default-center').split(',');
}

/* --------------- */
/*let fullItems;*/

function addZoomControls(_currMap, _currMapWrapper) {
    const $plus = _currMapWrapper.find('.js-zoom-in');
    const $minus = _currMapWrapper.find('.js-zoom-out');


    // Кастомные кнопки
    $plus.on('click.map', e => {
        e.preventDefault();
        _currMap.setZoom(_currMap.getZoom() + 1);
    });

    $minus.on('click.map', e => {
        e.preventDefault();
        _currMap.setZoom(_currMap.getZoom() - 1);
    });
}

function drawCountriesMarkers() {
    if (citiesMarkers.length > 0) return ;

    if (typeof points == 'undefined') {
        throw 'Points are not defined';
    }

    for (let i in points) {
        let country = points[i];
        let length = country.title.length * 7 +20;

        // создаем метку
        let marker = new ymaps.Placemark(
            [country.lat, country.lon],
            {
                title: country.title
            },
            $.extend(placemarkData, {
                iconShape: {
                    type: 'Rectangle',
                    // Прямоугольник описывается в виде двух точек - верхней левой и нижней правой.
                    coordinates: [
                        [-length/2, -28], [length/2, 0]
                    ]
                }
            })
        );

        bindCountryClick(marker, country, i);

        map.geoObjects.add(marker);

        countriesMarkers.push(marker);
    }

    function bindCountryClick(marker, country, index) {
        marker.events.add('click', function () {
            currentCountry = index;
            zoomCountry(country);
        });
    }
}

/**
 *
 */
function removeCountriesMarkers() {
    removeMarkers(countriesMarkers);
    countriesMarkers = [];
}

/**
 *
 * @param country
 */
function zoomCountry(country) {
    map.setCenter([country.lat, country.lon], defaultCountryZoom);
}
/**
 *
 */
function drawCitiesMarkers() {
    if (citiesMarkers.length > 0) return ;

    let i;
    let cities = [];

    if (currentCountry === false) {
        cities = allCities;
    } else {
        for (i = 0; i < points[currentCountry].cities.length; i++) {
            cities.push(points[currentCountry].cities[i]);
        }
    }

    for (i = 0; i < cities.length; i++) {
        let city = cities[i];
        let length = city.title.length * 7 +20;

        // создаем метку
        let marker = new ymaps.Placemark(
            [city.lat, city.lon],
            {
                title: city.title
            },
            $.extend(placemarkData, {
                iconShape: {
                    type: 'Rectangle',
                    // Прямоугольник описывается в виде двух точек - верхней левой и нижней правой.
                    coordinates: [
                        [-length/2, -28], [length/2, 0]
                    ]
                }
            })
        );

        bindCityClick(marker, city, i);

        map.geoObjects.add(marker);

        citiesMarkers.push(marker);
    }

    //setTimeout(function () {
    //    google.maps.event.trigger(citiesMarkers[0], 'click');
    //}, 50);

    function bindCityClick(marker, city, index) {
        marker.events.add('click', function () {
            currentCountry = city.country;
            currentCity = index;
            zoomCity(city);
        });
    }
}

/**
 *
 */
function removeCitiesMarkers() {
    removeMarkers(citiesMarkers);
    citiesMarkers = [];
}

/**
 *
 * @param city
 */
function zoomCity(city) {
    map.setCenter([city.lat, city.lon], city.zoom || defaultCityZoom);
}

/**
 *
 */
function drawOfficesMarkers() {
    if (officesMarkers.length > 0) return ;

    let i;
    let offices = [];

    if (currentCity === false) {
        offices = allOffices;
    } else {
        for (i = 0; i < points[currentCountry].cities[currentCity].offices.length; i++) {
            offices.push(points[currentCountry].cities[currentCity].offices[i]);
        }
    }

    for (i = 0; i < offices.length; i++) {

        let placemarkData = {
            iconLayout: ymaps.templateLayoutFactory.createClass(
                `<div class="map-point" data-index="${offices[i].items[0].id}">`
            ),
            iconOffset: [-32, -32],
            iconShape: {
                type: 'Circle',
                coordinates: [32, 32],
                radius: 32
            },
            zIndexHover: 999
        };

        // создаем метку
        let marker = new ymaps.Placemark(
            [offices[i].lat, offices[i].lon],
            {id: offices[i].items[0].id},
            placemarkData
            /*{
                iconLayout: 'default#image',
                iconImageHref: markerIcon,
                iconImageSize: [32, 32]
            }*/
        );

        bindOfficeClick(marker, offices[i], i);

        map.geoObjects.add(marker);

        officesMarkers.push(marker);
    }

    //setTimeout(function () {
    //    google.maps.event.trigger(officesMarkers[0], 'click');
    //}, 50);

    //function bindOfficeClick(marker, office, index) {
    function bindOfficeClick(marker, office) {
        marker.events.add('click', function (e) {
            currentCountry = office.country;
            currentCity = office.city;
            /*currentOffice = index;*/

            //removeOfficesMarkers();
            zoomOffice(office);
            /*drawOfficeMarker(office);*/

            let currId = e.get('target').properties.get('id');
            let $scrollToWrap = $(`.contacts-list-item[data-id="${currId}"]`);

            if ($scrollToWrap.hasClass('accordeon-item') && !$scrollToWrap.hasClass('_active')) {
                $scrollToWrap.find('.accordeon-item__button').trigger('click');

                setTimeout(function () {
                    scrollToElement($scrollToWrap);
                });
            } else {
                scrollToElement($scrollToWrap);
            }
        });
    }
}

/**
 *
 */
function removeOfficesMarkers() {
    removeMarkers(officesMarkers);
    officesMarkers = [];
}

/**
 * @param office
 * @param itemId - optional, if we want to show particular office
 */
//function drawOfficeMarker(office, itemId) {
function drawOfficeMarker(office) {
    // создаем метку
    officeMarker = new ymaps.Placemark(
        [office.lat, office.lon],
        {}, {
            iconLayout: 'default#image',
            iconImageHref: markerIcon,
            iconImageSize: [32, 32]
        }
    );

    map.geoObjects.add(officeMarker);
}

function removeOfficeMarker() {
    if (officeMarker) {
        map.geoObjects.remove(officeMarker);
    }
}
/**
 *
 * @param office
 */
function zoomOffice(office) {
    map.setCenter([office.lat, office.lon], defaultOfficeZoom);
}

/**
 *
 * @param markers
 */
function removeMarkers(markers) {
    for (let i = 0; i < markers.length; i++) {
        map.geoObjects.remove(markers[i]);
    }
}

function onZoomChange(event) {
    let zoom = event.get('newZoom');
    if (zoom == previousZoom) return;
    let up = previousZoom > zoom;
    if (zoom >= 1 && zoom < defaultCountryZoom) {
        removeCitiesMarkers();
        drawCountriesMarkers();
        if (up) {
            currentCountry = false;
        }
    } else if (zoom >= defaultCountryZoom && zoom <= 9) {
        removeCountriesMarkers();
        removeOfficeMarker();
        removeOfficesMarkers();
        drawCitiesMarkers();
        if (up) {
            currentCity = false;
        }
    } else if (zoom > 9 && zoom <= 13) {
        removeOfficeMarker();
        removeCitiesMarkers();
        drawOfficesMarkers();
        /*if (up) {
            currentOffice = false;
        }*/
    } else if (zoom > 13) {
        removeCitiesMarkers();
    }
    previousZoom = zoom;
}

/**
 * @param id
 * @returns {*}
 */
function findOfficeById(id) {
    let key = allOfficesById[id];
    return allOffices[key];
}

function showOnMap(id) {
    removeCountriesMarkers();
    removeCitiesMarkers();
    removeOfficeMarker();
    removeOfficesMarkers();

    let office = findOfficeById(id);

    if (!office) return false;

    currentCountry = office.country;
    currentCity = office.city;

    zoomOffice(office);


    if (App.mobile) {
        container.addClass('_mob-opened');
        setTimeout(function () {
            drawOfficeMarker(office, id);
            scrollToElement(container);
        }, 40);
    } else {
        drawOfficeMarker(office, id);
    }
}

// setup only once
if (firstLoad && container.length) {
    loadLibrary(LIB_URL.YAMAP, () => {
        ymaps.ready(function init() {
            let j, i, k, l;

            // дизайн метки с текстом
            placemarkData = {
                iconLayout: ymaps.templateLayoutFactory.createClass(
                    '<div style="position: absolute; text-align: center;"><div class="head-map-city-marker"><span>{{ properties.title }}</span></div></div>'
                )
            };

            container = $('.js-head-map');

            if (!container.length) return function () {};

            /*fullItems = $('.contacts-list-item');*/

            jsonURL = container.data('url');
            mapContainer = $('#head-map', container);

            // Создание карты.
            map = new ymaps.Map(mapContainer.get(0), mapOptions);
            map.behaviors.disable('scrollZoom');
            addZoomControls(map, container);

            //App.$.getJSON(jsonURL, function (data) {
            $.getJSON(jsonURL, function (data) {
                points = data;

                let officeKey = 0;

                // TODO: refactor
                for (j = 0; j < points.length; j++) {
                    for (i = 0; i < points[j].cities.length; i++) {
                        points[j].cities[i].country = j;
                        allCities.push(points[j].cities[i]);
                        for (k = 0; k < points[j].cities[i].offices.length; k++) {
                            let office = points[j].cities[i].offices[k];
                            office.country = j;
                            office.city = i;
                            allOffices.push(office);

                            for (l = 0; l < office.items.length; l++) {
                                //allOfficesById[office.items[l].id] = k;
                                allOfficesById[office.items[l].id] = officeKey;
                            }
                            officeKey++;
                        }
                    }
                }

                if (points.length == 1) {
                    zoomCountry(points[0]);
                } else {
                    drawCountriesMarkers();
                }


                ///todo: разобраться с метками: при инициализаии карты метки не отображаются, при изменении зума отображаются
                map.setZoom(map.getZoom() + 1);
                map.setZoom(map.getZoom() - 1);
                // end

            });

            $('.js-show-on-map').click(function (e) {
                let parent = $(this).closest('[data-id]');

                if (parent) {
                    scrollToElement($('.js-head-map'));
                    showOnMap(parent.data('id'));
                }

                e.preventDefault();
            });

            //setTimeout(function () {
            //    $('.js-show-on-map').eq(0).click();
            //}, 200);

            map.events.add('boundschange', onZoomChange);

            //App.doc.on('win:resizeBreakPoint:decrease:768', function () {
            /*App.D.on('win:resizeBreakPoint:decrease:768', function () {
             setTimeout(function () {
             App.getModule('StyledControls').renderSelects();
             }, 10);
             });*/

            //$('.js-map-close').click(mobileMapClose);

            firstLoad = false;
        });
    });
}

// print contacts item
/*let printControls = $('.js-print-contacts');
let printIframe = window.frames.print_frame;
let printCss = '<link href="/css/main.css" rel="stylesheet" type="text/css"/><link href="/css/print.css" rel="stylesheet" type="text/css"/>';

printControls.click(function () {
    printIframe.document.body.innerHTML = '<ul class="contacts-list"><li class="contacts-list-item clearfix">' + $(this).parents('.contacts-list-item').html() + '</li></ul>';
    printIframe.window.focus();
    printIframe.window.print();
});*/

